import React, { Component } from 'react';
import './AccountOverview.scss';
import { connect } from 'react-redux';
import  CircularProgress  from '@material-ui/core/CircularProgress';
import { getLoggedinUser } from '../../../../../Redux/Actions/EndUser/AuthActions';
import { setAccountLoader } from '../../../../../Redux/Actions/CommonActions';

class AccountOverview extends Component {
	componentDidMount() {
        this.props.getLoggedinUser();
	}
	render() {
		return (
			<div className="account-overview background-white">
				<h3 className="main-title">Account Overview</h3>
				<a href="/my-account" className="btnLink btn btn-sm btnPrimary">Edit Account Details</a>


                <div className="card mb-2 ">
                    {this.props.loading ? <div className="card m-2" style={{ verticalAlign: "middle", alignItems: 'center' }}>
                        <CircularProgress style={{ display: 'block', margin: 'auto' }} /> <label>Loading...</label>
                    </div> :
                        <ul className="list-group list-group-flush dashboard-info-list">
						<li className="list-group-item list-group-item-paragraph receiptItem">
							<div className="row">
								<div className="col-md-8">
									<p>
										<span className="minWidth">
											User Name: 
										</span>
										<span className="dashboard-info-text">
											{
												this.props.user.firstName !== null && this.props.user.lastName !== null ?
													`${this.props.user.firstName} ${this.props.user.lastName}`
													: ''
											}
										</span>
									</p>
								</div>
								<div className="col-md-4">
									<p>
										<span className="minWidth">
											Member Since: 
										</span>
										<span className="dashboard-info-text">
											{this.props.user.memberSince}
										</span>
									</p>
								</div>
								{/* <div className="col-md-6">
									<p>
										<span className="minWidth">
											Member Email:  
										</span>
										<span className="dashboard-info-text">
										{this.props.user.userName}
										</span>
									</p>
								</div> */}
							</div>
						</li>
					 </ul>
				} 

				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
    const { user, email, loading } = state.authentication;
    return {
        user,
		email,
		loading
    };
}

export default connect(mapStateToProps, { getLoggedinUser })(AccountOverview);
